import { render } from "./ribbons6.vue?vue&type=template&id=f95c2990"
import script from "./ribbons6.vue?vue&type=script&lang=js"
export * from "./ribbons6.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__